// extracted by mini-css-extract-plugin
export var csatScore = "_kt-5";
export var header = "_kt-1";
export var panelWrapper = "_kt-2";
export var postPreview = "_kt-3";
export var rightContent = "_kt-0";
export var wrappingText = "_kt-4";